// Texty přepínače zobrazení hesla (passwordToggle.js).
export default {
  show: 'Zobrazit',
  hide: 'Skrýt',
  a11yShow: 'Zobrazit heslo',
  a11yHide: 'Skrýt heslo',
};
